import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { FieldFilter, FilterField } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface CloneFieldFilterParams {
  fieldFilter: FieldFilter;
  name: string;
}

const cloneFieldFilter: MutationFunction<
  CloneFieldFilterParams,
  CloneFieldFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockStackFilter(args), { delay: 4000, failureRate: 1 });
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const currentFieldFilter = await authTokenHttp<{
    filter: {
      configuration: {
        fieldIds: FilterField[];
      };
      name: string;
      id: string;
      visibility: 'private' | 'public';
    };
  }>(`/search-filters/${args.fieldFilter.id}`, {
    method: 'GET',
  });
  if (!currentFieldFilter.data) throw new Error('Failed to get field filter');
  const response = await authTokenHttp<CloneFieldFilterParams>(
    '/search-filters',
    {
      method: 'POST',
      body: {
        type: 'field',
        visibility: 'private',
        configuration: {
          fieldIds:
            currentFieldFilter.data?.filter.configuration.fieldIds ?? [],
        },
        name: args.name,
      },
    },
  );

  if (response.data) return response.data;
  throw new Error('Failed to clone field filter');
};

export default cloneFieldFilter;

const _mockStackFilter = (fieldFilter: CloneFieldFilterParams) => {
  return {
    id: crypto.randomUUID(),
    ...fieldFilter,
  };
};
